<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Tambah Data</p>
                <argon-button color="success" size="sm" class="ms-auto" @click="save()"
                  >Simpan</argon-button
                >
                <argon-button color="danger" size="sm" class="mx-3" @click="back()"
                  >Kembali</argon-button
                >
              </div>
            </div>
            <div class="card-body">
              <tabs>
                <tab name="Informasi Jemaat">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nomor KK</label
                      >
                      <argon-input type="text" v-model:value="datas.ID_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Keluarga</label
                      >
                      <argon-input type="text" v-model:value="datas.keluarga.NAMA_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Wilayah</label
                      >
                      <VueMultiselect
                        v-model="datas.WILAYAH"
                        :options="data_wilayah"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="wilayah"
                        track-by="wilayah"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Sektor</label
                      >
                      <VueMultiselect
                        v-model="datas.SEKTOR"
                        :options="filtered_sektor"
                        :multiple="false"
                        :close-on-select="true"
                        :placeholder="datas.WILAYAH && datas.WILAYAH.id ? 'Pilih' : 'Pilih Wilayah terlebih dahulu'"
                        :disabled="!datas.WILAYAH || !datas.WILAYAH.id"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nama</label
                      >
                      <argon-input type="text" v-model:value="datas.NAMA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jenis Kelamin</label
                      >
                      <VueMultiselect
                        v-model="datas.JK"
                        :options="[{'id': 'L', 'nama':'Laki-Laki'},{'id': 'P', 'nama':'Perempuan'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Lahir</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_LAHIR" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Lahir</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_KELAHIRAN" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS"
                        :options="data_status"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status Aktif</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_AKTIF"
                        :options="[{'id': '1', 'nama':'Aktif'},{'id': '0', 'nama':'Tidak Aktif'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status Perkawinan</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_PERKAWINAN"
                        :options="data_perkawinan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Ayah</label
                      >
                      <argon-input type="text" v-model:value="datas.AYAH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Ibu</label
                      >
                      <argon-input type="text" v-model:value="datas.IBU" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kewarganegaraan</label
                      >
                      <argon-input type="text" v-model:value="datas.KEWARGANEGARAAN" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Golongan Darah</label
                      >
                      <VueMultiselect
                        v-model="datas.GOL_DARAH"
                        :options="data_goldar"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Baptis</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_BAPTIS" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Baptis</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_BAPTIS" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Sidi</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_SIDI" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Sidi</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_SIDI" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Dibaptis Oleh</label
                      >
                      <argon-input type="text" v-model:value="datas.DIBAPTIS_OLEH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Disidi Oleh</label
                      >
                      <argon-input type="text" v-model:value="datas.DISIDI_OLEH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan (Attestasi) Ke Gereja</label
                      >
                      <argon-input type="text" v-model:value="datas.PINDAHAN_KE" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan (Attestasi) Masuk</label
                      >
                      <argon-input type="text" v-model:value="datas.PINDAHAN" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindah</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_PINDAH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pendidikan Terakhir</label
                      >
                      <VueMultiselect
                        v-model="datas.PENDIDIKAN"
                        :options="data_pendidikan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jurusan</label
                      >
                      <argon-input type="text" v-model:value="datas.JURUSAN" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Disabilitas</label
                      >
                      <VueMultiselect
                        v-model="datas.DISABILITAS"
                        :options="[{'id': '0', 'nama':'Tidak'},{'id': '1', 'nama':'Ya'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan Agama</label
                      >
                      <VueMultiselect
                        v-model="PINDAHANS"
                        :options="[{'id': '0', 'nama':'Tidak'},{'id': '1', 'nama':'Dari Kristen'},{'id': '2', 'nama':'Ke Kristen'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Semayam</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_SEMAYAM" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Meninggal</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_MENINGGAL" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindahan Ke Kristen (Jika Ada)</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_AGAMA_LAIN" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindahan Dari Kristen (Jika Ada)</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_DARI_KRISTEN" />
                    </div>
                  </div>
                </tab>
                <tab name="Kontak Jemaat">
                  <div class="row">
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kota</label
                      >
                      <argon-input type="text" v-model:value="datas.KOTA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Provinsi</label
                      >
                      <argon-input type="text" v-model:value="datas.PROPINSI" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Negara</label
                      >
                      <argon-input type="text" v-model:value="datas.NEGARA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kodepos</label
                      >
                      <argon-input type="text" v-model:value="datas.KODEPOS" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Telp / HP</label
                      >
                      <argon-input type="text" v-model:value="datas.HP" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >e-mail</label
                      >
                      <argon-input type="text" v-model:value="datas.EMAIL" />
                    </div>
                  </div>
                </tab>
                <tab name="Data Pekerjaan, dll">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pekerjaan</label
                      >
                      <VueMultiselect
                        v-model="datas.PEKERJAAN"
                        :options="data_pekerjaan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Kerja / USAHA</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_KERJA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat Kerja / Usaha</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT_KERJA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Bidang Usaha</label
                      >
                      <argon-input type="text" v-model:value="datas.BIDANG_USAHA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jabatan / Pangkat</label
                      >
                      <VueMultiselect
                        v-model="datas.JABATAN"
                        :options="data_jabatan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Profesi</label
                      >
                      <VueMultiselect
                        v-model="datas.PROFESI"
                        :options="data_profesi"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Hobby</label
                      >
                      <VueMultiselect
                        v-model="HOBBY2"
                        :options="data_hobby"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Minat</label
                      >
                      <VueMultiselect
                        v-model="MINAT2"
                        :options="data_minat"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Minat Bidang Pelayanan</label
                      >
                      <VueMultiselect
                        v-model="MINAT_PELAYANAN2"
                        :options="data_pelayanan"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                  </div>
                </tab>
            </tabs>
            </div>
          </div>
        </div>
      </div>
    <auth-check></auth-check>
    </div>
  </main>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<script>
/* eslint-disable */
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import VueMultiselect from 'vue-multiselect'
import AuthCheck from '@/components/authCheck.vue'

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      datas: {
        id: 0,
        ALAMAT: "",
        ALAMAT_KERJA: "",
        AYAH: "",
        BIDANG_USAHA: "",
        DIBAPTIS_OLEH: "",
        DISIDI_OLEH: "",
        EMAIL: "",
        GOL_DARAH: "",
        HOBBY: "",
        HOBBY2: "",
        HOBBYETC: "",
        HP: "",
        IBU: "",
        ID_JEMAAT: 0,
        ID_KELUARGA: 0,
        JABATAN: "",
        JABATANETC: "",
        JK: "",
        JURUSAN: "",
        KEWARGANEGARAAN: "",
        KODEPOS: "",
        KOTA: "",
        MINAT: "",
        MINAT2: "",
        MINATETC: "",
        MINAT_PELAYANAN2: "",
        MINAT_PELAYANAN: "",
        NAMA: "",
        NEGARA: "",
        PEKERJAAN: "",
        PEKERJAANETC: "",
        PENDIDIKAN: "",
        PERAN: "",
        PERANETC: "",
        PINDAHAN: "",
        PINDAHAN_KE: "",
        PINDAHAN_AGAMA_LAIN: "",
        PINDAHAN_DARI_KRISTEN: "",
        PROFESI: "",
        PROFESIETC: "",
        PROPINSI: "",
        SEKTOR: 0,
        STATUS: "1",
        STATUS_AKTIF: "1",
        STATUS_PERKAWINAN: "",
        TANGGAL_MENINGGAL: null,
        TANGGAL_PINDAH: null,
        TEMPAT_BAPTIS: "",
        TEMPAT_KELAHIRAN: "",
        TEMPAT_KERJA: "",
        TEMPAT_SEMAYAM: null,
        TEMPAT_SIDI: "",
        TGL_AGAMA_LAIN: "",
        TGL_BAPTIS: "",
        TGL_DARI_KRISTEN: "",
        TGL_LAHIR: "",
        TGL_SIDI: "",
        WILAYAH: 0,
        DISABILITAS: "",
        keluarga: {
          ID_KELUARGA: 0,
          NAMA_KELUARGA: "",
        },
      },
      MINAT2: "",
      HOBBY2: "",
      MINAT_PELAYANAN2: "",
      PINDAHANS: "",
      data_wilayah: [],
      data_sektor: [],
      data_gaji: [],
      data_minat: [],
      data_goldar: [],
      data_hobby: [],
      data_jabatan: [],
      data_kewarganegaraan: [],
      data_klasifikasi: [],
      data_negara: [],
      data_pekerjaan: [],
      data_pelayanan: [],
      data_pendidikan: [],
      data_perkawinan: [],
      data_profesi: [],
      data_status: [],
      data_statusKeluarga: [],
    };
  },
  components: { 
    ArgonInput, 
    VueMultiselect,
    ArgonButton, 
    AuthCheck, 
  },
  computed: {
    filtered_sektor() {
      if (!this.datas.WILAYAH || !this.datas.WILAYAH.id) return [];
      return this.data_sektor.filter(s => s.id_wilayah === this.datas.WILAYAH.id);
    }
  },
  watch: {
    'datas.WILAYAH'(newVal, oldVal) {
      if (oldVal && newVal && oldVal.id !== newVal.id) {
        this.datas.SEKTOR = null;
      }
    },
    PEKERJAAN(newVal){
      console.log(newVal)
    },
    MINAT_PELAYANAN2(newVal){
      var pelayantemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        pelayantemp += element.nama + ", "
      });
      this.datas.MINAT_PELAYANAN = pelayantemp.slice(0, -2)
    },
    MINAT2(newVal){
      var minattemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        minattemp += element.nama + ", "
      });
      this.datas.MINAT = minattemp.slice(0, -2)
    },
    HOBBY2(newVal){
      console.log(newVal)

      var hobbytemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        hobbytemp += element.nama + ", "
      });
      this.datas.HOBBY = hobbytemp.slice(0, -2)
    }
  },
  methods: {
    back(){
      this.$router.push("/data-jemaat");
    },
    save(){
      if(this.PINDAHANS.id == "0"){
        this.datas.PINDAHAN_AGAMA_LAIN = "0"
        this.datas.PINDAHAN_DARI_KRISTEN = "0"
      } else if(this.PINDAHANS.id == "1"){
        this.datas.PINDAHAN_AGAMA_LAIN = "0"
        this.datas.PINDAHAN_DARI_KRISTEN = "1"
      } else {
        this.datas.PINDAHAN_AGAMA_LAIN = "1"
        this.datas.PINDAHAN_DARI_KRISTEN = "0"
      }
      var url = ""
      var data = {
        "ALAMAT": this.datas.ALAMAT,
        "ALAMAT_KERJA": this.datas.ALAMAT_KERJA,
        "AYAH": this.datas.AYAH,
        "BIDANG_USAHA": this.datas.BIDANG_USAHA,
        "DIBAPTIS_OLEH": this.datas.DIBAPTIS_OLEH,
        "DISIDI_OLEH": this.datas.DISIDI_OLEH,
        "EMAIL": this.datas.EMAIL,
        "GOL_DARAH": this.datas.GOL_DARAH != null ? JSON.parse(JSON.stringify(this.datas.GOL_DARAH)).nama : null,
        "HOBBY": this.datas.HOBBY,
        "HP": this.datas.HP,
        "IBU": this.datas.IBU,
        "JABATAN": this.datas.JABATAN != null ? JSON.parse(JSON.stringify(this.datas.JABATAN)).nama : null,
        "JK": this.datas.JK != null ? JSON.parse(JSON.stringify(this.datas.JK)).id : null,
        "JURUSAN": this.datas.JURUSAN,
        "KEWARGANEGARAAN": this.datas.KEWARGANEGARAAN,
        "KODEPOS": this.datas.KODEPOS,
        "KOTA": this.datas.KOTA,
        "MINAT": this.datas.MINAT,
        "MINAT_PELAYANAN": this.datas.MINAT_PELAYANAN,
        "NAMA": this.datas.NAMA,
        "NEGARA": this.datas.NEGARA,
        "PEKERJAAN": this.datas.PEKERJAAN != null ? JSON.parse(JSON.stringify(this.datas.PEKERJAAN)).nama : null,
        "PENDIDIKAN": this.datas.PENDIDIKAN != null ? JSON.parse(JSON.stringify(this.datas.PENDIDIKAN)).nama : null,
        "PINDAHAN": this.datas.PINDAHAN,
        "PROFESI": this.datas.PROFESI != null ? JSON.parse(JSON.stringify(this.datas.PROFESI)).nama : null,
        "PROPINSI": this.datas.PROPINSI,
        "SEKTOR": this.datas.SEKTOR != null ? JSON.parse(JSON.stringify(this.datas.SEKTOR)).id : null,
        "STATUS": this.datas.STATUS != null ? JSON.parse(JSON.stringify(this.datas.STATUS)).id : null,
        "STATUS_AKTIF": this.datas.STATUS_AKTIF != null ? JSON.parse(JSON.stringify(this.datas.STATUS_AKTIF)).id : null,
        "STATUS_PERKAWINAN": this.datas.STATUS_PERKAWINAN != null ? JSON.parse(JSON.stringify(this.datas.STATUS_PERKAWINAN)).nama : null,
        "TANGGAL_MENINGGAL": this.datas.TANGGAL_MENINGGAL,
        "TANGGAL_PINDAH": this.datas.TANGGAL_PINDAH,
        "TEMPAT_BAPTIS": this.datas.TEMPAT_BAPTIS,
        "TEMPAT_KELAHIRAN": this.datas.TEMPAT_KELAHIRAN,
        "TEMPAT_KERJA": this.datas.TEMPAT_KERJA,
        "TEMPAT_SEMAYAM": this.datas.TEMPAT_SEMAYAM,
        "TEMPAT_SIDI": this.datas.TEMPAT_SIDI,
        "TGL_BAPTIS": this.datas.TGL_BAPTIS,
        "TGL_LAHIR": this.datas.TGL_LAHIR,
        "TGL_SIDI": this.datas.TGL_SIDI,
        "DISABILITAS": this.datas.DISABILITAS != null ? JSON.parse(JSON.stringify(this.datas.DISABILITAS)).id : null,
        "TGL_AGAMA_LAIN": this.datas.TGL_AGAMA_LAIN,
        "TGL_DARI_KRISTEN": this.datas.TGL_DARI_KRISTEN,
        "PINDAHAN_AGAMA_LAIN": this.datas.PINDAHAN_AGAMA_LAIN,
        "PINDAHAN_DARI_KRISTEN": this.datas.PINDAHAN_DARI_KRISTEN,
        "WILAYAH": JSON.parse(JSON.stringify(this.datas.WILAYAH)).id,
      }
      if(this.datas.id == "0"){
        url = "add"
        this.axios.post(process.env.VUE_APP_API_URL + "jemaat/" + url, data, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then(() => {
          this.$toast.open({
              message: 'Data Tersimpan!',
              type: 'success',
          });
          this.$router.push({
            name: "Data Jemaat",
          })
        }).catch((ex) => {
          console.log(ex)
          this.$toast.open({
              message: 'Terjadi Kesalahan, cek Console!',
              type: 'error',
          });
        });
      } else {
        url = "update"
        data.id = this.datas.id
        this.axios.put(process.env.VUE_APP_API_URL + "jemaat/" + url, data, {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then(() => {
        this.$toast.open({
            message: 'Data Tersimpan!',
            type: 'success',
        });
        this.$router.push({
          name: "Data Jemaat",
        })
      }).catch((ex) => {
        console.log(ex)
        this.$toast.open({
            message: 'Terjadi Kesalahan, cek Console!',
            type: 'error',
        });
      });
      }
    }
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
      "Authorization": "Bearer " + localStorage.getItem("token")
    }}).then((resp) => {
      this.data_wilayah = JSON.parse(JSON.stringify(resp.data)).wilayah
      this.data_sektor = JSON.parse(JSON.stringify(resp.data)).sektor
      this.data_gaji = JSON.parse(JSON.stringify(resp.data)).gaji
      this.data_goldar = JSON.parse(JSON.stringify(resp.data)).goldar
      this.data_hobby = JSON.parse(JSON.stringify(resp.data)).hobby
      this.data_jabatan = JSON.parse(JSON.stringify(resp.data)).jabatan
      this.data_kewarganegaraan = JSON.parse(JSON.stringify(resp.data)).kewarganegaraan
      this.data_klasifikasi = JSON.parse(JSON.stringify(resp.data)).klasifikasi
      this.data_negara = JSON.parse(JSON.stringify(resp.data)).negara
      this.data_pekerjaan = JSON.parse(JSON.stringify(resp.data)).pekerjaan
      this.data_pelayanan = JSON.parse(JSON.stringify(resp.data)).pelayanan
      this.data_pendidikan = JSON.parse(JSON.stringify(resp.data)).pendidikan
      this.data_perkawinan = JSON.parse(JSON.stringify(resp.data)).perkawinan
      this.data_profesi = JSON.parse(JSON.stringify(resp.data)).profesi
      this.data_status = JSON.parse(JSON.stringify(resp.data)).status
      this.data_statusKeluarga = JSON.parse(JSON.stringify(resp.data)).statusKeluarga
      this.data_minat = JSON.parse(JSON.stringify(resp.data)).minat

      if(this.$route.params.id != null && this.$route.params.id != "0"){
        this.axios.get(process.env.VUE_APP_API_URL + "jemaat/"+this.$route.params.id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          this.datas = JSON.parse(JSON.stringify(resp.data.data))
          if(this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "1" && Date(this.datas.TGL_AGAMA_LAIN) < Date(this.datas.TGL_DARI_KRISTEN)){
            this.PINDAHANS = {'id': '1', 'nama':'Dari Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "1" && Date(this.datas.TGL_AGAMA_LAIN) > Date(this.datas.TGL_DARI_KRISTEN)){
            this.PINDAHANS = {'id': '2', 'nama':'Ke Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "0"){
            this.PINDAHANS = {'id': '2', 'nama':'Ke Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "0" && this.datas.PINDAHAN_DARI_KRISTEN == "1"){
            this.PINDAHANS = {'id': '1', 'nama':'Dari Kristen'}
          } else {
            this.PINDAHANS = {'id': '0', 'nama':'Tidak'}
          }

          if(this.datas.STATUS_AKTIF == "1"){
            this.datas.STATUS_AKTIF = {'id': '1', 'nama':'Aktif'}
          } else {
            this.datas.STATUS_AKTIF = {'id': '0', 'nama':'Tidak Aktif'}
          }

          if (this.datas.MINAT != null){
            this.MINAT2 = this.data_minat.filter(x => this.datas.MINAT.split(", ").includes(x.nama));
          }
          if (this.datas.MINAT_PELAYANAN != null){
            this.MINAT_PELAYANAN2 = this.data_pelayanan.filter(x => this.datas.MINAT_PELAYANAN.split(", ").includes(x.nama));
          }
          if (this.datas.HOBBY != null){
            this.HOBBY2 = this.data_hobby.filter(x => this.datas.HOBBY.split(", ").includes(x.nama));
          }
          if (this.datas.keluarga == null){
            this.datas.keluarga = {'ID_KELUARGA': '-', 'NAMA_KELUARGA': '-'}
          }
        })
      }
    });
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
